import { LoyaltyInfo, useCustomer } from "../contexts/CustomerContext";
import { findLoyaltyBusiness } from "../utils/loyaltyBusiness";

/** The business this loyalty is shared across, or null when it's the location's own. */
export function useLoyaltyBusiness(loyalty: LoyaltyInfo | null | undefined) {
  return findLoyaltyBusiness(loyalty, useCustomer().loyaltyBusinesses);
}
